import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";

import { to_load_audio_madnes } from "./madnes_variables";

import AbstractAudio from "../AbstractAudio";
import SystemConfig from "../../system/SystemConfig";
import InitResult from "../../connect/result/InitResult";

import { madnes_adapter } from "./madnes_variables";

import {
	madnes_audio_fade_in,
	madnes_audio_fade_out,
	madnes_audio_get_volume,
	madnes_audio_is_playing,
	madnes_audio_play,
	madnes_get_audio_level_volume,
	set_audio_decoded,
	set_muted,
	sounds,
} from "./madnes_audio";
import { main_phaser } from "./MadnesApp";
import { madnes_tween_to } from "./madnes_tween";
import { AUDIO_EVENTS } from "../AbstractAudio";
import eventsObservable from "../../events/EventsObservable";
import Settings from "../../settings/Settings";

@injectable()
export default class MadnesAudio extends AbstractAudio {
	private _fadeInTween: any;

	constructor(@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig) {
		super(config);
	}

	onInitSuccess(settings: Settings) {
		this.gamesetTracks = this.gamesetTracks.concat(
			getAudioTracks(madnes_adapter.to_load_audio)
		);
		this.gamesetTracks = this.gamesetTracks.concat(
			getAudioTracks(to_load_audio_madnes)
		);

		madnes_adapter.set_sounds(settings.getSoundBehavConfig());
	}

	loadComplete(data: any) {
		for (let track of this.gamesetTracks) {
			sounds[track.name] = main_phaser.add.audio(track.name);
			sounds[track.name].volume = madnes_get_audio_level_volume(track.name);
		}

		set_audio_decoded(true);
		this.mute();
	}

	audioFadeIn(duration: number, easing?: Function) {
		if (!super.unmuteAllowed()) return;
		this._fadeInTween = madnes_tween_to(
			main_phaser.sound,
			{ volume: 1 },
			{ duration: 1000 }
		);
	}

	mute(): boolean {
		let mutedTmp = this.muted;

		this.muted = true;
		this._fadeInTween && this._fadeInTween.stop();
		main_phaser.sound.volume = 0;
		eventsObservable.dispatch(AUDIO_EVENTS.AUDIO_MUTED, true, mutedTmp);
		set_muted(true);
		return true;
	}

	unmute(): boolean {
		if (!this.choosed || !super.unmuteAllowed()) {
			return false;
		}

		let mutedTmp = this.muted;

		this.muted = false;
		main_phaser.sound.volume = 0;
		this.audioFadeIn(500);
		eventsObservable.dispatch(AUDIO_EVENTS.AUDIO_MUTED, false, mutedTmp);
		// this.dispatch({type: AUDIO_EVENTS.AUDIO_MUTED, data: false });
		set_muted(false);
		return true;
	}

	isPlaying(name: string): boolean {
		return madnes_audio_is_playing(name);
	}

	getTrackNames() {
		return Object.keys(sounds);
	}

	fadeOutTrack(
		name,
		duration,
		stop = true,
		callback = undefined,
		ease = undefined
	) {
		madnes_audio_fade_out(name, duration, stop, callback, ease);
	}
	fadeInTrack(name, duration) {
		madnes_audio_fade_in(name, duration);
	}

	playTrack(name: string, vol?: number) {
		//console.log(name, this.getDefaultVolume(name, vol));
		//madnes_audio_set_volume(name, this.getDefaultVolume(name, vol));
		madnes_audio_play(name);
	}

	getVolume(name: string): number {
		return madnes_audio_get_volume(name) || 0;
	}

	getDefaultVolume(name, vol?: number): number {
		// if(vol != null) {
		//     return vol;
		// }
		return madnes_get_audio_level_volume(name) || vol || 0;
	}
}
export function getAudioTracks(audioList = {}) {
	let tracks = [];

	for (let key in audioList) {
		let track = {
			name: key,
			url: audioList[key],
		};

		tracks.push(track);
	}

	return tracks;
}
